<div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
    <ms-page-title />

    <section class="mb-3">
        <p class="text-muted">Need help? Send a message to the HOA Start Support team and we'll get back to you shortly.</p>
        <ms-contact-support-form></ms-contact-support-form>
    </section>

    <div class="d-flex justify-content-end align-items-center gap-3 mt-4">
        <!-- Label stays in the DOM (invisible) while submitting so the button keeps its natural width;
             the spinner overlays absolute-centered so the layout doesn't shift. -->
        <button type="button" class="btn btn-primary position-relative"
            [disabled]="isSubmitting()"
            (click)="attemptSubmit()">
            <span [class.invisible]="isSubmitting()">
                <fa-duotone-icon icon="paper-plane" class="me-2" />
                Submit
            </span>
            @if (isSubmitting()) {
                <div class="spinner-border text-light spinner-border-sm position-absolute top-50 start-50 translate-middle"
                    role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            }
        </button>
    </div>

    <ms-info-modal #submitResultModal [modalId]="submitResultModalId" (onConfirm)="onResultAcknowledged()" />
</div>
